import { render, staticRenderFns } from "./CollapsableMenu.vue?vue&type=template&id=90c6b366&"
import script from "./CollapsableMenu.vue?vue&type=script&lang=ts&"
export * from "./CollapsableMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports